import React, { useState } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";

const Layout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const menuItems = [
    { path: "/backoffice", label: "דשבורד", icon: "📊" },
    { path: "/backoffice/users", label: "משתמשים", icon: "👥" },
    { path: "/backoffice/admins", label: "מנהלי מערכת", icon: "🛡️" },
    {
      path: "/backoffice/calculation-parameters",
      label: "פרמטרי חישוב",
      icon: "🔧",
    },
    { path: "/backoffice/explanations", label: "הסברי חישוב", icon: "📝" },
    { path: "/backoffice/epa-data", label: "נתוני EPA", icon: "🇺🇸" },
    { path: "/backoffice/articles", label: "מאמרים", icon: "📰" },
    { path: "/backoffice/coupons", label: "קופונים", icon: "🎟️" },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex" dir="rtl">
      {/* Overlay למובייל */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* תפריט צידי */}
      <div
        className={`
        fixed lg:static inset-y-0 right-0 z-30
        w-64 bg-white shadow-lg
        transform transition-transform duration-300 ease-in-out
        ${sidebarOpen ? "translate-x-0" : "translate-x-full lg:translate-x-0"}
      `}
      >
        <div className="p-6 h-full flex flex-col">
          {/* לוגו + כפתור סגירה במובייל */}
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center">
              <img src="/logo.svg" alt="CarTax" className="h-8 w-8 ml-3" />
              <h1 className="text-xl font-bold text-blue-600">CarTax</h1>
            </div>
            <button
              onClick={() => setSidebarOpen(false)}
              className="lg:hidden text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>

          {/* תפריט ניווט */}
          <nav className="space-y-2 flex-1">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setSidebarOpen(false)}
                className={`w-full flex items-center px-4 py-3 text-right rounded-lg transition-colors ${
                  location.pathname === item.path
                    ? "bg-blue-100 text-blue-700 font-semibold"
                    : "text-gray-700 hover:bg-gray-100"
                }`}
              >
                <span className="ml-3">{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            ))}
          </nav>

          {/* פרטי המשתמש ויציאה */}
          <div className="pt-6 border-t border-gray-200">
            <div className="flex items-center justify-between">
              <div className="text-sm text-gray-600">
                <p className="font-medium">{user?.email || "משתמש"}</p>
                <p className="text-xs">מנהל מערכת</p>
              </div>
              <button
                onClick={handleLogout}
                className="text-red-600 hover:text-red-800 text-sm"
                title="יציאה"
              >
                🚪
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* תוכן ראשי */}
      <div className="flex-1 overflow-auto lg:mr-0">
        <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-10">
          <div className="px-6 py-4 flex items-center justify-between">
            {/* כפתור hamburger למובייל */}
            <button
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden text-gray-600 hover:text-gray-800 text-2xl"
            >
              ☰
            </button>
            <h2 className="text-2xl font-bold text-gray-900">
              {menuItems.find((item) => item.path === location.pathname)
                ?.label || "דשבורד"}
            </h2>
            {/* Spacer לאיזון במובייל */}
            <div className="w-8 lg:hidden"></div>
          </div>
        </header>

        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
